import React from 'react';
import { DropdownField, MenuItem } from '@one-thd/sui-atomic-components';
import { useAddresses } from '../../../hooks/use-addresses';
import { addressToString } from '../../../utils/address';
export const AddressDropdownSelector = ({ selectedAddrID, onChange, onBlur, disabled, name, status, statusMessage, }) => {
    const { addresses } = useAddresses();
    const addressList = [...((addresses === null || addresses === void 0 ? void 0 : addresses.addresses) || [])];
    const selectedAddressIdx = addressList.findIndex((address) => address.addrIdentifier === selectedAddrID);
    if (addressList.length > 1 && selectedAddressIdx > -1) {
        const [tempEl] = [...addressList];
        addressList[0] = addressList[selectedAddressIdx];
        addressList[selectedAddressIdx] = tempEl;
    }
    return (React.createElement(DropdownField, { label: "Billing Address *", status: status, statusMessage: statusMessage, fullWidth: true, value: selectedAddrID, onChange: (event) => {
            const value = parseInt(event.target.value, 10);
            if (!Number.isNaN(value)) {
                onChange(value);
            }
        }, disabled: disabled, dropdownProps: {
            onBlur,
            name,
        } }, addressList.slice(0, 20).map((address) => {
        return (React.createElement(MenuItem, { id: address.addrIdentifier, key: address.addrIdentifier, value: address.addrIdentifier }, addressToString(address)));
    })));
};
